import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<string, { isExpandable: boolean }>(
  {
    title: {
      color: 'var(--x-black)',
      fontSize: 14,
      fontWeight: 600,
      marginBlockEnd: ({ isExpandable }) => (isExpandable ? 0 : 16),
      textTransform: 'uppercase',
    },
    container: {
      alignItems: 'center',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'space-between',
      marginBlock: 16,
    },
    icon: {
      fill: 'var(--x-text-color-4)',
      transition: 'all 0.5s',
    },
    iconReversed: {
      transform: 'rotate(180deg)',
    },
  },
  {
    name: 'FooterTitle',
  },
);

export default useStyles;
